import { IMapUserToExternalUser } from './models/MapUserToExternalUser';
import {BaseService} from "../../base-service";
import {RegistrationLookups} from "./RegistrationLookups";
import {IUserRegistrationRequest} from './models/UserRegistrationRequest';

const basePath = '/api/v1/userregistration';

const registrationPath ='register';
const lookUpsPath='lookups';

const createUrl = (actionPath:any)=>{
    return `${basePath}/${actionPath}`;
}


export const registerUser=async (request:IUserRegistrationRequest):Promise<any>=>{
    return await BaseService.AsyncAnonymousPost(createUrl(registrationPath), request);
}

export const getLookups=async ():Promise<RegistrationLookups>=>{
    return await BaseService.AsyncAnonymousGet(createUrl(lookUpsPath));
}

export const mapUsers = async (request: IMapUserToExternalUser) : Promise<any> => {
    const path = `/api/v1/users/map-users`;
    return await BaseService.AsyncPost(path, request);
}

export const saveUserAttempts = async () :Promise<any> => {
    const path = `/api/v1/users/save-user-attempts`;
    return await BaseService.AsyncPostEmptyBody(path);
}

export const getUserAttempts = async () :Promise<any> => {
    const path = `/api/v1/users/get-user-attempts`;
    return await BaseService.AsyncGet(path);
}